// @flow
import type { AppRenderActions } from '../types/app_render';

export const changeAppRenderAction = (setting_type: string, payload: object): AppRenderActions => {
    return {
        type: 'CHANGE_APP_RENDER',
        setting_type,
        payload,
    };
};
